import { TblCol, TblFltOption } from '../../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import {
    PAYOR_MED_TYPE_MANAGED,
    PAYOR_MED_TYPE_MEDICAID,
    PAYOR_STATUS_ACTIVE,
    PAYOR_STATUS_INACTIVE,
} from '../../payor_const';
import CreatedByRenderer from './renderers/CreatedByRenderer';
import ModifiedByRenderer from './renderers/ModifiedByRenderer';
import { TblViewSpec } from '../../../../core/table/table-view.types';

export type ColKey =
    | ''
    | 'BIN'
    | 'PCN'
    | 'GroupNumber'
    | 'State'
    | 'Name'
    | 'MedType'
    | 'ObjectState'
    | 'CreatedCol'
    | 'CreatedBy'
    | 'CreatedDate'
    | 'ModifiedCol'
    | 'ModifiedBy'
    | 'ModifiedDate';

function medTypeOptions(): TblFltOption[] {
    return [
        { lbl: 'ALL', val: '' },
        { lbl: PAYOR_MED_TYPE_MANAGED, val: PAYOR_MED_TYPE_MANAGED },
        { lbl: PAYOR_MED_TYPE_MEDICAID, val: PAYOR_MED_TYPE_MEDICAID },
    ];
}
function statusOptions(): TblFltOption[] {
    return [
        { lbl: 'ALL', val: '' },
        { lbl: PAYOR_STATUS_ACTIVE, val: PAYOR_STATUS_ACTIVE },
        { lbl: PAYOR_STATUS_INACTIVE, val: PAYOR_STATUS_INACTIVE },
    ];
}

// column spec (map the keys to the column types)
export function payorListColumnSpec(): Map<ColKey, TblCol> {
    const map = new Map<ColKey, TblCol>();
    tblSpecAddColumn<ColKey>(map, 'BIN', { width: '35px' });
    tblSpecAddColumn<ColKey>(map, 'PCN', { width: '40px' });
    tblSpecAddColumn<ColKey>(map, 'GroupNumber', { title: 'Group Number', width: '40px' });
    tblSpecAddColumn<ColKey>(map, 'State', { width: '20px' });
    tblSpecAddColumn<ColKey>(map, 'Name', { title: 'Description', width: '60px' });
    tblSpecAddColumn<ColKey>(map, 'MedType', {
        type: 'DROPTEXT',
        title: 'Type',
        width: '40px',
        fltOptions: medTypeOptions(),
    });
    tblSpecAddColumn<ColKey>(map, 'ObjectState', {
        type: 'DROPTEXT',
        title: 'Status',
        width: '40px',
        fltOptions: statusOptions(),
    });
    tblSpecAddColumn<ColKey>(map, 'CreatedBy', { title: 'Created By', width: '60px' }, CreatedByRenderer);
    tblSpecAddColumn<ColKey>(map, 'ModifiedBy', { title: 'Modified By', width: '60px' }, ModifiedByRenderer);
    return map;
}

// default view
export function payorListDefaultView(): TblViewSpec {
    return {
        key: '0',
        title: 'Default',
        sections: [
            {
                title: 'Identifiers',
                cols: ['BIN', 'PCN', 'GroupNumber', 'State'],
            },
            {
                title: 'Payor',
                cols: ['Name'],
            },
            {
                title: 'Usage',
                cols: ['MedType', 'ObjectState', 'CreatedBy', 'ModifiedBy'],
            },
        ],
        sortby: 'BIN',
    };
}
